import { Route } from 'react-router-dom';
import { ADVISOR_PATH } from './api/indexAdvisor';
import { IndexAdvisorPage } from './pages/IndexAdvisor';
import { CandidatePage } from './pages/CandidatePage';

/** The index advisor's routes; a candidate's page is gated by the list's path (it is not a nav node). */
export function indexAdvisorRoutes(allowed: (path: string) => boolean, scopes: readonly string[]) {
  if (!allowed(ADVISOR_PATH)) return [];
  return [
    <Route key={ADVISOR_PATH} path={ADVISOR_PATH} element={<IndexAdvisorPage scopes={scopes} />} />,
    <Route
      key={`${ADVISOR_PATH}/:scanId/:candidateId`}
      path={`${ADVISOR_PATH}/:scanId/:candidateId`}
      element={<CandidatePage />}
    />,
  ];
}
